module.exports = __webpack_public_path__ + "blackfoot.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackfoot.png
// module id = 854
// module chunks = 0